import { PERMISSION_KEYS } from '../../permissions/constants';

// For navitems and quick actions
export const PERMISSIONS_ID_MAP: Record<string, string> = {
  mis_report: PERMISSION_KEYS.HR_MIS,
  'utilization-trends': PERMISSION_KEYS.HR_UT,
  'utilisation-trends': PERMISSION_KEYS.HR_UT,
  'download-ecard': PERMISSION_KEYS.HR_ECARD
};

// Preauth and claims page
export const PERMISSIONS_KEY_MAP: Record<string, string> = {
  'letter': PERMISSION_KEYS.HR_LETTER,
  'letters': PERMISSION_KEYS.HR_LETTER,
  'documents': PERMISSION_KEYS.HR_DOC,
};
